import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../Assets/img/logo-small.png';
import Loader from '../../component/Loader';

const useHandleToken = () => {
    const navigate = useNavigate();
    const [isRedirecting, setIsRedirecting] = useState(false);

    useEffect(() => {
        localStorage.removeItem('validationerror');

        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

     

        if (token) {
            localStorage.setItem('token', token);
            setIsRedirecting(true);

            setTimeout(() => {
                const baseUrl = window.location.origin;
                const additionalPath = '/#/college/collegedashboard';
                const newUrl = baseUrl + additionalPath;
                window.location.href = newUrl;
            }, 1000); // Delay of 1 seconds (1000 milliseconds)

        }
        else {

            localStorage.setItem('validationerror', 'login failed');
            const baseUrl = window.location.origin;
            const additionalPath = '/#/college';
            const newUrl = baseUrl + additionalPath;
            window.location.href = newUrl;
        }

    }, [navigate]);

    return isRedirecting;
};


export default function Validation() {
    const isRedirecting = useHandleToken();

    return isRedirecting ? (
        // <div className='body23'>
        //     <div className="container23">
        //         <div className="login-box23" style={{ minHeight: "50%", alignContent: "center" }}>
        //             <div className="card-body d-flex justify-content-center align-items-center" >
        //                 <div className="containeranimate">
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                 </div>
        //             </div>

        //         </div>
        //     </div>
        // </div>
        <Loader />
    ) : null;
}
